import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus(complexDenominator, c1, r1, sImaginary) {
  var result = Complex.createComplex(1, c1 * r1 * sImaginary).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexRParallel, r2) {
  var result = complexRParallel.divide(Complex.createComplex(r2, 0));
  return result;
}
